module.exports = __webpack_public_path__ + "img/zhijvyun2.87b2ef0c.png";